import * as React from "react";
import { IconNames } from "@blueprintjs/icons";
import { ETLCodes } from "../../locales";
import { useTl } from "../../hooks";
import { ICustomButtonProps } from "./ICustomButtonProps";
import { Intent, Button } from "@blueprintjs/core";
import { useAuth } from "../../contexts";

interface ICloseButtonProps extends ICustomButtonProps {
  secured?: boolean;
}

export const CloseButton: React.FunctionComponent<ICloseButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY,
  text,
  secured = true,
}) => {
  const { t } = useTl();
  const { getCurrentPermission } = useAuth();
  const hasRights = React.useMemo(() => getCurrentPermission()?.permission.includes("RW"), [getCurrentPermission]);
  return (
    (hasRights || !secured) && (
      <Button
        icon={IconNames.TICK_CIRCLE}
        minimal={minimal}
        onClick={onClick}
        text={text || (minimal ? null : t(ETLCodes.Close))}
        intent={intent}
        loading={loading}
        disabled={disabled || (secured && !hasRights)}
      />
    )
  );
};
